import React from 'react';

import { SVGComponentProps } from './svg.types';

const AddSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherSvgProps}
      >
        <path
          d="M10.7148 4.71429H7.37191C7.32744 4.71128 7.28556 4.69225 7.25404 4.66073C7.22252 4.62921 7.20349 4.58734 7.20048 4.54286V1.28572C7.21305 1.1209 7.19129 0.95527 7.13658 0.799295C7.08186 0.64332 6.99538 0.500395 6.88259 0.379556C6.76981 0.258717 6.63318 0.162593 6.48135 0.0972611C6.32951 0.0319297 6.16577 -0.00118785 6.00048 2.49512e-06C5.83078 -0.00313779 5.66218 0.0279727 5.50477 0.0914741C5.34736 0.154976 5.20437 0.249564 5.08435 0.369585C4.96433 0.489606 4.86974 0.632595 4.80624 0.790004C4.74274 0.947413 4.71163 1.11601 4.71477 1.28572V4.62857C4.71176 4.67305 4.69273 4.71493 4.66121 4.74645C4.62969 4.77797 4.58781 4.79699 4.54334 4.8H1.2862C1.11989 4.78007 0.951242 4.7967 0.792033 4.84872C0.632823 4.90074 0.486895 4.98691 0.364448 5.10119C0.242001 5.21548 0.145989 5.35512 0.0831228 5.51037C0.0202563 5.66562 -0.00794805 5.83272 0.000481067 6C0.00874349 6.3384 0.146855 6.66064 0.386205 6.89999C0.625556 7.13934 0.947803 7.27745 1.2862 7.28572H4.62905C4.67353 7.28873 4.7154 7.30775 4.74693 7.33927C4.77845 7.37079 4.79747 7.41267 4.80048 7.45715V10.8C4.79636 10.9587 4.82458 11.1166 4.88342 11.2641C4.94227 11.4115 5.03051 11.5455 5.14277 11.6577C5.25503 11.77 5.38897 11.8582 5.53643 11.9171C5.68388 11.9759 5.84177 12.0041 6.00048 12C6.33887 11.9917 6.66112 11.8536 6.90047 11.6143C7.13982 11.3749 7.27793 11.0527 7.2862 10.7143V7.37143C7.2892 7.32696 7.30823 7.28508 7.33975 7.25356C7.37127 7.22204 7.41315 7.20301 7.45762 7.2H10.8005C11.1167 7.19344 11.4181 7.0649 11.6417 6.84126C11.8654 6.61763 11.9939 6.3162 12.0005 6C12.0145 5.82761 11.9908 5.65424 11.9311 5.49191C11.8715 5.32957 11.7772 5.18214 11.6549 5.05984C11.5326 4.93755 11.3852 4.8433 11.2229 4.78363C11.0605 4.72396 10.8872 4.7003 10.7148 4.71429Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default AddSVG;
